<template>
	<div class="d-flex flex-column">

		<div class="w-auto">
			<div class="w-auto">
				<label>{{ groupLabel }}</label>
				<select v-model="group" class="select w-100">
					<option v-for="group in groups" :key="group.id_group" :value="group">{{ group.name_group }}</option>
				</select>
			</div>
			<div class="pt-5">
				<label>{{ pcLabel }}</label>
				<select :disabled="!group" v-model="pcInGroup" class="select w-100">
					<option v-for="pc in $session.getPCList()" :key="pc.id" v-if="groupHasPC(group, pc.id)"
					:disabled="selectIfOnline && !$root.connectionsStates[pc.id]" :value="pc">
					<span>{{ `${pc.pc_name || ''}`}}</span>
					<span v-if="pc.organization_name">{{ ` (${pc.organization_name || ''})` }}</span>
					<span v-if="!$root.connectionsStates[pc.id]"> ({{ $t(pc.notConnectedDefaultMessage)}})</span>
				</option>
				</select>
			</div>
			<div v-if="showSATestMsg" class="mt-2">
				<small class="text-muted">
					<span class="mif-info mr-1" />
					<span>{{ $t("The group and device are selected solely for the purpose of testing the credentials provided. Once validation is successfully completed, the service account can be used by any device.") }}</span>
				</small>
			</div>
			<div v-if="showBkpMsg" class="mt-2">
				<p>
					<span class="mif-info mr-1" />
					<span>{{ $t("Please note: in order to configure a backup on a remote computer, you must first install the Iperius One Agent on it.") }}</span>
				</p>
			</div>
		</div>
	</div>
			
</template>
<script>
export default {
	name: "SelectPCByGroup",
	props: {
	groupLabel: String,
		pcLabel: String,
		idPC: [String, Number],
		idCustomer: [String, Number],
		showSATestMsg:Boolean,
		showBkpMsg:Boolean,
		selectIfOnline:Boolean
	},
	data() {
		return {
			group: null,
			pcInGroup: null,
			groups : null
		}
	},
	watch: {
		pcInGroup: {
			handler: function(value) {
				if (value==null) {
					return;
				}
				this.$emit("selectPC", value);
			}
		}
	},
	created(){
		this.groups = (this.$session.getGroups()||[]).filter(group =>
			this.idCustomer==null||this.idCustomer===''||group.id_customer==this.idCustomer
		);
		if(!this.idPC){
			return;
		}

		this.pcInGroup = this.$session.getPCWithID(this.idPC);
		this.group = this.groups.find(g => this.groupHasPC(g, this.idPC))
	},
	methods: {
		groupHasPC(group, idPC) {
			return !!group&&Array.isArray(group.ids_computers)&&group.ids_computers.some(id => id==idPC);
		}
	}

}
</script>
